import React, { FunctionComponent, ReactNode, Fragment } from "react";

type GarageBadgeProps = {
  icon: ReactNode;
  name: string;
  hint?: string;
};

export const GarageBadge: FunctionComponent<GarageBadgeProps> = (props: GarageBadgeProps) => {
  const [showHint, setShowHint] = React.useState(false);

  return (
    <Fragment>
      <div className="text-white bg-warning px-2 md:px-4 py-1 md:py-2 rounded-br md:rounded-bl flex items-center">
        {props.icon}
        <div className="text-xs md:text-sm flex font-bold">{props.name}</div>
        {props.hint && (
          <div
            className={"ml-2"}
            onMouseOver={() => setShowHint(true)}
            onMouseOut={() => setShowHint(false)}
          >
            <svg width="13" fill="white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
              <path d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM256 464c-114.7 0-208-93.31-208-208S141.3 48 256 48s208 93.31 208 208S370.7 464 256 464zM296 336h-16V248C280 234.8 269.3 224 256 224H224C210.8 224 200 234.8 200 248S210.8 272 224 272h8v64h-16C202.8 336 192 346.8 192 360S202.8 384 216 384h80c13.25 0 24-10.75 24-24S309.3 336 296 336zM256 192c17.67 0 32-14.33 32-32c0-17.67-14.33-32-32-32S224 142.3 224 160C224 177.7 238.3 192 256 192z" />
            </svg>
          </div>
        )}
      </div>
      {props.hint && showHint && (
        <div className={"absolute left-44 ml-2 text-xs bg-white shadow text-center w-36 p-2"}>
          {props.hint}
        </div>
      )}
    </Fragment>
  );
};
